import React, { useEffect, useState } from "react";
import ContainerPop from "../../../Pops/ContainerPop";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

const OfferModal = ({
  show,
  handleClose,
  formData,
  services,
  handleAddService,
}) => {
  const [selectedService, setSelectedService] = useState({
    ourServiceId: "",
    ourService: "",
    days: "",
    countTicket: "",
    description: "",
  });

  const handleServiceChange = (e) => {
    const { name, value } = e.target;
    const service = services.find((service) => service.id === value);
    setSelectedService((prev) => ({
      ...prev,
      [name]: value,
      ourService: service?.name,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedService((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addService = () => {
    handleAddService(selectedService);
    setSelectedService({
      ourServiceId: "",
      ourService: "",
      days: "",
      countTicket: "",
      description: "",
    });
  };

  useEffect(() => {
    if (
      selectedService.ourServiceId === 1 ||
      selectedService.ourServiceId === 9 ||
      selectedService.ourServiceId === 10 ||
      selectedService.ourServiceId === 11
    ) {
      setSelectedService((prev) => ({
        ...prev,
        countTicket: 0,
      }));
    }
  }, [selectedService.ourServiceId]);

  return (
    <div
      className={`fixed inset-0 z-50 flex justify-center items-center ${
        show ? "block" : "hidden"
      } bg-black bg-opacity-50`}
      onClick={handleClose}
    >
      <ContainerPop>
        <div
          className="w-[32em] max-w-full bg-secondary dark:bg-darkPrimary text-textColor dark:text-darkTextColor rounded-lg p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">Add Services</h2>
            <IoMdCloseCircleOutline
              onClick={handleClose}
              size={"2rem"}
              className="cursor-pointer"
            />
          </div>
          <div>
            <FormControl fullWidth margin="normal">
              <InputLabel id="service-select-label">Service</InputLabel>
              <Select
                labelId="service-select-label"
                id="service-select"
                name="ourServiceId"
                label="Service"
                value={selectedService.ourServiceId || ""}
                onChange={handleServiceChange}
                className="text-start"
              >
                {services.map((service) => (
                  <MenuItem key={service.id} value={service.id}>
                    {service.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {selectedService.ourServiceId && (
              <>
                <TextField
                  fullWidth
                  margin="normal"
                  label="Days"
                  name="days"
                  type="number"
                  required
                  autoComplete="off"
                  value={formData.days}
                  onChange={handleInputChange}
                  variant="outlined"
                />
                {selectedService.ourServiceId !== 1 &&
                  selectedService.ourServiceId !== 9 &&
                  selectedService.ourServiceId !== 10 &&
                  selectedService.ourServiceId !== 11 && (
                    <TextField
                      fullWidth
                      margin="normal"
                      label="Count ticket"
                      name="countTicket"
                      type="number"
                      required
                      autoComplete="off"
                      value={formData.countTicket}
                      onChange={handleInputChange}
                      variant="outlined"
                    />
                  )}

                <TextField
                  fullWidth
                  margin="normal"
                  label="Description"
                  name="description"
                  required
                  autoComplete="off"
                  value={formData.description}
                  onChange={handleInputChange}
                  variant="outlined"
                />
              </>
            )}
            <Button
              variant="outlined"
              onClick={addService}
              className="mt-4"
              fullWidth
              disabled={
                !selectedService.description ||
                !selectedService.days ||
                !selectedService.ourServiceId ||
                (selectedService.ourServiceId !== 1 &&
                  selectedService.ourServiceId !== 9 &&
                  selectedService.ourServiceId !== 10 &&
                  selectedService.ourServiceId !== 11 &&
                  !selectedService.countTicket)
              }
            >
              Add Service
            </Button>
          </div>
        </div>
      </ContainerPop>
    </div>
  );
};

export default OfferModal;
